import type { DocumentLocale } from '../utils/documentLocale';

export const LATEST_PRIVACY_POLICY_VERSION = '1.0.0';

export const privacyPolicyJsonUrl = (
    version: string,
    locale: DocumentLocale = 'tr'
): string => {
    const fileName =
        locale === 'en' ? `${version}.en.json` : `${version}.json`;
    return `${process.env.PUBLIC_URL}/policies/${fileName}`;
};
